import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BLACK } from 'constants/colors';
export default makeStyles(theme => createStyles({
  accordionRoot: {
    width: '100%',
    color: BLACK
  },
  accordionSummary: {
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  accordionSummaryTitles: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    paddingLeft: theme.spacing(2),
    alignItems: 'center'
  }
}));